export default __webpack_public_path__ + "assets/phil.972f9045.png";